import React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import RamSizeTypeahead from './RamSizeTypeahead';

export const RamSize = ({
    fromRamSize,
    toRamSize,
    onChange,
    disabled,
    classes,
    t
}) => (
    <Box className={classes.specificationWrapper}>
        <InputLabel
            className={classes.inputLabelSpecification}
            shrink
            variant="standard"
        >
            {t('ramSize')}
        </InputLabel>
        <Box className={classes.SpecificationBox}>
            <FormControl
                fullWidth
                margin="dense"
                className={classes.formControlWrapper}
            >
                <RamSizeTypeahead
                    animatedPlaceholder
                    labelId="from"
                    isClearable
                    name="from"
                    value={fromRamSize}
                    onChangeSuggestion={onChange('fromRamSizeTypes')}
                    disabled={disabled}
                    t={t}
                />

            </FormControl>
            <FormControl
                fullWidth
                margin="dense"
                className={classes.formControlWrapper}
            >
                <RamSizeTypeahead
                    animatedPlaceholder
                    labelId="to"
                    isClearable
                    name="to"
                    value={toRamSize}
                    onChangeSuggestion={onChange('toRamSizeTypes')}
                    disabled={disabled}
                    t={t}
                />
            </FormControl>
        </Box>
    </Box>
);
